<!--
  @Description 协助人选择框
  @Date 2021-12-30
  @Author liushuo
-->
<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    :title="title"
    width="50%"
    @show="showModal"
    @close="closeModal"
  >
    <div class="modal-dv">
      <el-form
        :model="form"
        ref="FormRef"
        :validate-on-rule-change="false"
        :rules="rules"
        size="small"
        label-position="left"
        label-width="auto"
      >
        <!-- 前端 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="前端研发" prop="frontEngineer">
              <el-select clearable filterable v-model="form.frontEngineer" size="small" placeholder="选择前端人员">
                <el-option
                  v-for="i of selectOptions.frontEngineer"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <div class="error-icon">
                  {{ slot.error }}
                </div>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 后端 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="后端研发" prop="backEngineer">
              <el-select clearable filterable v-model="form.backEngineer" size="small" placeholder="选择后端人员">
                <el-option
                  v-for="i of selectOptions.backEngineer"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <div class="error-icon">
                  {{ slot.error }}
                </div>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="问题内容" prop="content">
              <el-input
                type="textarea"
                :rows="8"
                v-model="form.content"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
                :disabled="false"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <div class="error-icon">
                  {{ slot.error }}
                </div>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="说明" prop="comment">
              <el-input
                type="textarea"
                :rows="8"
                v-model="form.comment"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
                :disabled="false"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <div class="error-icon">
                  {{ slot.error }}
                </div>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 确认按钮 -->
      <el-button @click="handleCommit" style="float: right; margin-top: 10px" size="medium" type="primary"
        >确认</el-button
      >
    </div>
  </vxe-modal>
</template>
<script>
export default {
  name: 'addRoleModal',
  props: {
    parentObj: Object,
    // 标题
    title: {
      type: String,
      default: '选择'
    },
    // 当前选中行id
    curSelectRowID: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      formVisible: false,
      form: {
        frontEngineer: '',
        backEngineer: '',
        content: '',
        comment: ''
      },
      selectOptions: {
        frontEngineer: [],
        backEngineer: []
      },
      rules: {
        frontEngineer: [{ required: true, message: '请选择前端研发人员', trigger: 'change' }],
        backEngineer: [{ required: true, message: '请选择后端研发人员', trigger: 'change' }],
        content: [
          // {
          //   min: 0,
          //   max: 2000,
          //   message: '长度在 0 到 2000 个字符',
          //   trigger: 'change'
          // },
          { required: true, message: '请输入问题内容', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    showModal() {
      // 获取开发人员数据
      this.getFrontPerson()
      this.getBackPerson()

      // 初始化人员
      this.form.frontEngineer = ''
      this.form.backEngineer = ''
    },
    closeModal() {
      this.form = {
        frontEngineer: '',
        backEngineer: '',
        content: '',
        comment: ''
      }
    },
    // 获取前端人员数据
    async getFrontPerson() {
      this.selectOptions.frontEngineer = []

      const { data: res } = await this.$http.post('/Common/YKUser/list', {
        pageIndex: 1,
        pageSize: 99999,
        sqlTitle: 'post:前端研发'
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data.rows) {
        const temp = {
          name: item.name,
          value: item.name
        }
        this.selectOptions.frontEngineer.push(temp)
      }
    },
    // 获取后端人员数据
    async getBackPerson() {
      this.selectOptions.backEngineer = []

      const { data: res } = await this.$http.post('/Common/YKUser/list', {
        pageIndex: 1,
        pageSize: 99999,
        sqlTitle: 'post:后端研发'
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data.rows) {
        const temp = {
          name: item.name,
          value: item.name
        }
        this.selectOptions.backEngineer.push(temp)
      }
    },
    handleCommit() {
      this.validEnter().then(async result => {
        if (result) {
          // 调用添加协助人接口
          this.addPart()

          this.$nextTick(() => {
            this.formVisible = false
          })
        }
      })
    },
    // 验证
    async validEnter() {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 增加协助人
    async addPart() {
      const { data: res } = await this.$http.post('/Common/YKCase/addpart', {
        id: this.curSelectRowID,
        frontEngineer: this.form.frontEngineer,
        backEngineer: this.form.backEngineer,
        content: this.form.content,
        comment: this.form.comment
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)

      // 问题汇总主界面的原型
      const rootDOM = this.$parent.$parent.$parent
      // 刷新问题汇总主界面（因为有新增，所以要全量刷新）
      rootDOM.getList()
    }
  }
}
</script>
<style lang="less" scoped>
.modal-dv {
  box-sizing: border-box;
  padding: 0 10px;
}

.error-icon {
  // position: absolute;
  right: 2px;
  // margin-top: 6px;
  z-index: 10;
  color: #f56c6c;
  top: 0 !important;
}

// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}

.el-row {
  margin-bottom: 12px !important;
}
.el-row:last-child {
  margin-bottom: 0px !important;
}
</style>
